/** @format */

import React from "react";
import PrimaryButton from "../../Inputs/PrimaryButton";
import InputField from "../../Inputs/InputField";
import { Form, Formik } from "formik";
import { Dialog } from "../../Layout/dialogBox/dialog";
import { useCreateOrUpdate } from "../../../Hooks/useCreateOrUpdate";
import { colors } from "../../../Constants/theme";
import SecondaryButton from "../../Inputs/secondaryButton";
import * as yup from "yup";
import { useAlert } from "../../Layout/Alerts/Index";
import { useMediaQuery } from "@mui/material";
import SelectField from "../../Inputs/SelectField/Index";
import { GrUserAdd } from "react-icons/gr";

const validationSchema = yup.object().shape({
  s_name: yup.string().required("Sponsor name is required"),
  no_of_students: yup.number().required("Number is required"),
  since: yup.date().required("Start date is required"),
  // end_date: yup.date(),

  address: yup.string().required("Address is required"),
  donation_type: yup.object().required("Donation type is required"),
});

function AdminPanelDialog({ onSuccess }) {
  const phone = useMediaQuery("(max-width:751px)");

  const { mutate, isLoading } = useCreateOrUpdate({
    url: "/records/sponsors/nt/",
    method: "post",
  });
  const addAlert = useAlert();

  return (
    <div>
      <Dialog
        title={"Add Sponsor"}
        onClose={() => {}}
        button={
          <PrimaryButton
            sx={{
              height: "45px",
              fontSize: "1rem",
              borderRadius: "8px",
              fontWeight: 500,
              color: colors.text.main,
            }}
          >
            Add Sponsor
            <GrUserAdd size={20} className='ms-1 text-white' />
          </PrimaryButton>
        }
      >
        {({ onClose }) => (
          <Formik
            initialValues={{
              s_name: "",
              since: "",
              end_date: "",
              donation_type: "",
              address: "",
              no_of_students: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              const formData = new FormData();
              formData.append("s_name", values.s_name);
              formData.append("since", values.since);
              formData.append("end_date", values.end_date || "");
              formData.append("donation_type", values.donation_type.value);
              formData.append("address", values.address);
              formData.append("no_of_students", values.no_of_students);

              mutate(formData, {
                onSuccess: (response) => {
                  addAlert(
                    "Add sponsor successfully!",
                    "success",
                    {
                      vertical: "top",
                      horizontal: "right",
                    },
                    3000
                  );
                  onSuccess();
                  onClose();
                },
                onError: (error) => {
                  addAlert(
                    `${error}error`,
                    "error",
                    {
                      vertical: "top",
                      horizontal: "center",
                    },
                    3000
                  );
                },
              });
            }}
          >
            {({ setFieldValue, values }) => (
              <Form className='flex flex-col items-center max-tablet:px-0'>
                <div className='flex w-full flex-wrap gap-4 justify-center items-center gap-y-2 max-tablet:flex-col max-tablet:gap-4'>
                  <div className='w-[46%] max-tablet:w-[100%]'>
                    <InputField
                      name='s_name'
                      label='Sponsor Name'
                      placeholder='Enter title name'
                    />
                  </div>
                  <div className='w-[46%] max-tablet:w-[100%]'>
                    <InputField
                      name='since'
                      type={"date"}
                      label='Start Date'
                      placeholder='Enter date'
                    />
                  </div>
                  <div className='w-[46%] max-tablet:w-[100%]'>
                    <InputField
                      name='end_date'
                      type={"date"}
                      label='End Date'
                      placeholder='Enter date'
                    />
                  </div>
                  <div className='w-[46%] max-tablet:w-[100%]'>
                    <InputField
                      name='no_of_students'
                      label='Number of students'
                      type={"number"}
                      placeholder='Enter number of students'
                    />
                  </div>
                  <div className='w-[46%] max-tablet:w-[100%]'>
                    <InputField
                      name='address'
                      label='Address'
                      placeholder='Enter address'
                    />
                  </div>
                  <div className='w-[46%] max-tablet:w-[100%]'>
                    <SelectField
                      name='donation_type'
                      options={[
                        { label: "Monthly", value: "Monthly" },
                        { label: "Half yearly", value: "Half-Yearly" },
                        { label: "Yearly", value: "Yearly" },
                      ]}
                      label='Donation Type'
                      sx={{
                        "& .MuiInputBase-root.MuiOutlinedInput-root ": {
                          height: phone ? "45px" : "",
                        },
                      }}
                      placeholder='Donation type'
                    />
                  </div>
                </div>
                <div className='flex flex-row gap-4 mt-12'>
                  <SecondaryButton
                    onClick={onClose}
                    className='w-[69px] h-[32px] border border-[#082F49]'
                    sx={{
                      height: "44px",
                      width: "100px",
                      border: `1px solid ${colors.primary.dark}`,
                      borderRadius: "5px",
                      fontSize: "1rem",
                      fontWeight: 500,
                    }}
                  >
                    Cancel
                  </SecondaryButton>
                  <PrimaryButton
                    isLoading={isLoading}
                    sx={{
                      height: "44px",
                      width: "100px",
                      borderRadius: "5px",
                      fontSize: "1rem",
                      fontWeight: 500,
                    }}
                    type='submit'
                  >
                    Save
                  </PrimaryButton>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </Dialog>
    </div>
  );
}

export default AdminPanelDialog;
